import { useQuery } from '@tanstack/react-query';
import http from 'helpers/requests';
import queryClient from '../../../queryClient';

const fetchLoggedInOperator = async () => {
  const response = await http.get('/operators');
  return response.data.operator;
};

export const useFetchLoggedInOperator = () => {
  return useQuery({
    queryKey: ['loggedOperator'],
    queryFn: fetchLoggedInOperator,
    // Backs an editable form. Refetching on window focus replaces the record
    // reference mid-edit, which churns the form's derived defaults — leave it
    // off so switching tabs never disturbs in-progress input.
    refetchOnWindowFocus: false,
  });
};

// Awaitable variant for flows that must not proceed without the operator
// record (e.g. emissions report generation). Joins any request the hook
// already has in flight, or serves the fresh cache.
export const ensureLoggedInOperator = () =>
  queryClient.fetchQuery({
    queryKey: ['loggedOperator'],
    queryFn: fetchLoggedInOperator,
  });
